<template>
    <a-row>
        <a-col :md="12">
            <a-card title="账号信息" size="small" style="" :bordered="false">
                <a-descriptions>
                    <a-descriptions-item label="用户名">{{ username}}</a-descriptions-item>
                    <a-descriptions-item label="UID">{{ userid }}</a-descriptions-item>
                    <a-descriptions-item label="QQ">{{ qq }}</a-descriptions-item>
                </a-descriptions>
            </a-card>
            <a-card title="成就" size="small" :bordered="false">
                <a-row v-for="item of achievement" :key="item.id" :gutter="16" class="achievement">
                    <a-col v-if="item.type == 'text'" :title="item.details" :offset="2">
                        <a-icon :type="getIcon(item.classification)"></a-icon>
                        <span >{{ item.name }}</span>
                    </a-col>
                </a-row>
            </a-card>
        </a-col>
        <a-col :md="12">
            <a-card title="安全" size="small" style="" :bordered="false">
                <account-item label="密码" :has="true" comment="">
                    *******
                </account-item>
                <account-item label="邮箱" :has="!!email" comment="设置邮箱后，可通过邮箱找回密码">
                    {{ email }}
                </account-item>
            </a-card>
            <a-card title="操作" size="small" style="" :bordered="false">
                <a-button icon="poweroff" type="danger" @click="logout">退出登录</a-button>
            </a-card>
        </a-col>
    </a-row>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex'
import AccountItem from '../components/AccountItem.vue'

export default {
    computed: {
        ...mapState('$user', [
            'username', 'userid', 'email', 'qq', 'achievement',
        ]),
    },
    methods: {
        bindEmail() {

        },
        getIcon(classification) {
            switch(classification) {
                case '身份': return 'idcard';
                case '拆塔比赛': return 'trophy';
                case '造塔比赛': return 'trophy';
                case '限时活动': return 'team';
                case '造塔活动': return 'team';
                case '比赛主办': return 'schedule';
                case '比赛协力': return 'schedule';
            }
        },
        async logout() {
            await axios.get("/backend/user/logout.php");
            window.location.pathname = "/user/login.html";
        }
    },
    components: {
        AccountItem
    }
}
</script>

<style scoped>
.ant-card {
    background: none;
}
.ant-card >>> .ant-card-head-title {
    font-size: 18px;
    font-weight: bold;
}
.ant-descriptions {
    font-size: 16px;
}
</style>